import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeViewComponent } from './treeview.component';
import { TreeViewModule } from './treeview.module';
/**
 * NgModule definition for the TreeView component with providers.
 */
export class TreeViewAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, TreeViewModule],
    exports: [
        TreeViewModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TreeViewAllModule_tsickle_Closure_declarations() {
/** @type {?} */
TreeViewAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TreeViewAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
